import script from "./CheckboxInput.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckboxInput.vue?vue&type=script&setup=true&lang=js"

import "./CheckboxInput.vue?vue&type=style&index=0&id=5202ce2a&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5202ce2a"]])

export default __exports__